import axios from 'axios'

/**
 * バックエンドから返される生徒向けお知らせデータをフロントエンド用に正規化
 * @param {Object} announcement - バックエンドからのお知らせデータ
 * @returns {Object} 正規化されたお知らせデータ
 */
const normalizeStudentAnnouncement = (announcement) => ({
	id: announcement.id,
	title: announcement.title,
	content: announcement.content,
	// バックエンドのスネークケースをフロントエンドのキャメルケースに変換
	createdAt: announcement.created_at,
	isRead: announcement.is_read,
	type: announcement.type,
	isGlobal: announcement.is_global
})

export const announcement = {
	namespaced: true,
	state: {
		announcements: [],
		loading: false,
		unreadCount: 0
	},
	getters: {
		loading: (state) => {
			return state.loading
		},
		announcements: (state) => {
			return state.announcements
		},
		unreadCount: (state) => {
			return state.unreadCount
		},
		unreadAnnouncements: (state) => {
			return state.announcements.filter((announcement) => !announcement.isRead)
		}
	},
	mutations: {
		prepareConnect(state) {
			state.loading = true
		},
		stopLoading(state) {
			state.loading = false
		},
		setAnnouncements(state, payload) {
			// バックエンドから返されるデータをフロントエンド用に正規化
			state.announcements = payload.map(normalizeStudentAnnouncement)
			state.unreadCount = state.announcements.filter((announcement) => !announcement.isRead).length
			state.loading = false
		},
		markAsRead(state, announcementId) {
			const announcement = state.announcements.find((a) => a.id === announcementId)
			if (announcement && !announcement.isRead) {
				announcement.isRead = true
				state.unreadCount = state.announcements.filter((a) => !a.isRead).length
			}
		},
		updateUnreadCount(state) {
			state.unreadCount = state.announcements.filter((announcement) => !announcement.isRead).length
		}
	},
	actions: {
		// 生徒向けお知らせ一覧を取得
		async fetchAnnouncements({ commit }, payload) {
			commit('prepareConnect')

			const header = {
				headers: {
					Authorization: `Bearer ${payload.accessToken}`
				}
			}

			try {
				const response = await axios.get(`/api/announcements/student/${payload.studentId}`, header)
				commit('setAnnouncements', response.data.announcements)
			} catch (error) {
				commit('stopLoading')
				console.error('お知らせの取得に失敗しました:', error)
				throw error
			}
		},

		// お知らせを既読にする
		async markAnnouncementAsRead({ commit }, payload) {
			const header = {
				headers: {
					Authorization: `Bearer ${payload.accessToken}`
				}
			}

			try {
				await axios.patch(`/api/announcements/${payload.announcementId}/read/${payload.studentId}`, {}, header)
				commit('markAsRead', payload.announcementId)
			} catch (error) {
				console.error('既読マークに失敗しました:', error)
				throw error
			}
		}
	}
}
